import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=b71a53e4&scoped=true"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"
import style0 from "./rule.vue?vue&type=style&index=0&id=b71a53e4&lang=scss&scoped=true"
import style1 from "./rule.vue?vue&type=style&index=1&id=b71a53e4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71a53e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b71a53e4')) {
      api.createRecord('b71a53e4', component.options)
    } else {
      api.reload('b71a53e4', component.options)
    }
    module.hot.accept("./rule.vue?vue&type=template&id=b71a53e4&scoped=true", function () {
      api.rerender('b71a53e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/HostessRank/rule.vue"
export default component.exports